/* For when we'll implement role base feature switch (https://pandascore.atlassian.net/browse/BET-1952)
 * We could use something of this form :

 *    Record<Feature, {
 *      type: UserType,
 *      role?: UserRole,
 *      access_scopes?: string (list of access scopes that are exposed from tangerine)
 *    }[]>
 *
 * Other idea : we could use an object of the form :
 *
 *    Record<Feature, Record<UserType, UserRole[]>>
 *
 */

const assertFeatures = <T extends Record<string, UserType[]>>(obj: T): T => obj;

const FEATURES_SWITCH = assertFeatures({
  AUTOMATED_BOOKING_WITH_TIERING: ['bookmaker'],
  BETBUILDER_DEMO: ['trial'],
  BETBUILDER_MARKET_STATUS_OVERRIDE: ['pandascore'],
  BETBUILDER: ['pandascore', 'bookmaker'],
  BLACKLIST: ['pandascore'],
  BLUEPRINTS_COVERAGE_SELECTION: ['bookmaker'],
  BLUEPRINTS: ['pandascore', 'bookmaker'],
  BOOK_BETBUILDER: ['bookmaker'],
  BOOKMAKER_INPUT: ['bookmaker'],
  COMPETITORS: ['pandascore'],
  CONTROLE_LINKS: ['pandascore'],
  DISPLAY_OVERROUND: ['pandascore', 'trial'],
  EDIT_MATCH_BLUEPRINT: ['bookmaker'],
  EVENTS_PAGE: ['pandascore', 'bookmaker', 'trial'],
  EXTERNAL_PROVIDERS_MATCHES_BLUEPRINT: ['bookmaker'],
  HOTJAR: ['pandascore', 'bookmaker', 'trial'],
  INCIDENTS: ['bookmaker', 'trial', 'pandascore'],
  LADDER: ['bookmaker'],
  LIVE_CHAT: ['bookmaker', 'trial'],
  MARKET_AVAILABILITY_SETTINGS: ['bookmaker'],
  MARKET_HISTORY: ['pandascore', 'bookmaker'],
  MATCH_PAGE: ['pandascore', 'bookmaker', 'trial'],
  MATCH_REPORT: ['pandascore'],
  MICROBETTING: ['pandascore'],
  MONITORING: ['pandascore'],
  OUTRIGHTS_BLUEPRINTS: ['bookmaker'],
  OUTRIGHTS: ['pandascore', 'bookmaker'],
  PANDAODDS_VERSION: ['pandascore'],
  REALTIME_BETLOG: ['pandascore'],
  REALTIME_LOGS: ['pandascore'],
  REALTIME_PROVIDER: ['pandascore'],
  RESEND_SETTLEMENTS: ['bookmaker'],
  RISK_MANAGEMENT: ['pandascore'],
  SCHEDULE_PM_VIEW: ['pandascore'],
  SCRAPER_SCOREBOARD: ['pandascore'],
  STEAM_DATA: ['pandascore'],
  SUSPENSION_OVERRIDE: ['bookmaker'],
  TEAM_MANAGEMENT: ['bookmaker'],
  TOGGLE_EXTERNAL_PROVIDERS_MATCHES: ['pandascore', 'bookmaker', 'trial'],
  TRADER_INPUT: ['pandascore'],
  TRADING_WITH_GRID: ['pandascore']
});

type Feature = keyof typeof FEATURES_SWITCH;

export type { Feature };
export { FEATURES_SWITCH };
